import styled from 'styled-components'

const MainContainer = styled.div<{ $showDataPicker: boolean }>`
  position: absolute;
  top: 206px;
  left: 0;
  width: fit-content;
  text-align: center;
  z-index: 99999;
  background-color: #fff;
  display: ${(props) => (props.$showDataPicker ? 'block' : 'none')};
  .month-container {
    width: fit-content;
    display: flex;
    flex-direction: column;
    background: 'red';
    border-radius: 4px;
    padding: 16px;
    border: 0.1rem solid #29292929;
    box-shadow: 2px 4px 24px 0px #0d0d0d14;
  }
  .select-container {
    display: flex;
    align-items: center;
    gap: 4px;
    width: 144px;
    justify-content: center;
  }
  .select-data-picker {
    text-align: center;
    border: none;
    box-shadow: none;
    font-size: 14px;
    font-weight: 500;
  }
  .month-btn {
    background: transparent;
    display: flex;
    justify-content: center;
    opacity: 0.5;
    border: none;
    display: flex;
    align-items: center;
    transition: all 0.3s ease;
    cursor: pointer;
    width: 24px;
    height: 24px;
    align-items: center;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .arrow-icon {
    width: 1.6rem;
    height: 1.6rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: 'red';
  }
`

const SevenColonGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  .week-days {
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0;
    font-family: Inter;
  }
`
const Header = styled.div`
  display: flex;
  justify-content: space-evenly;
  height: 32px;
  align-items: center;
`

export { MainContainer, SevenColonGrid, Header }
